import React from "react";

function VORForm() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden; /* Hide all elements on the page */
            }
            #VORForm, #VORForm * {
              visibility: visible; /* Make only the form and its children visible */
            }
            #VORForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            /* Hide print button during printing */
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div id="VORForm" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Vehicle Off Road (VOR) Form</h3>

        <form>
          {/* Vehicle Registration */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="vehicleRegistration">
              Vehicle Registration:
            </label>
            <input
              type="text"
              id="vehicleRegistration"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter vehicle registration"
            />
          </div>

          {/* Date VOR Notified */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="dateVORNotified">
              Date VOR Notified:
            </label>
            <input
              type="date"
              id="dateVORNotified"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Reported By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="reportedBy">
              Reported By (Name):
            </label>
            <input
              type="text"
              id="reportedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name"
            />
          </div>

          {/* Reason for VOR */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="reasonForVOR">
              Reason for VOR:
            </label>
            <div className="flex flex-wrap items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Major Defect</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Accident</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Scheduled Maintenance</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Other</span>
              </label>
            </div>
          </div>

          {/* Detailed Description of Issue */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="issueDescription">
              Detailed Description of Issue:
            </label>
            <textarea
              id="issueDescription"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe the issue in detail, including location on the vehicle, safety concerns, and any impact on operations"
            />
          </div>

          {/* VOR Status */}
          <div className="mb-4">
            <h4 className="text-xl font-semibold mb-4 text-gray-800">VOR Status</h4>

            {/* Estimated Return Date */}
            <div className="mb-4">
              <label className="block text-lg font-medium text-gray-700" htmlFor="estimatedReturnDate">
                Estimated Return Date:
              </label>
              <input
                type="date"
                id="estimatedReturnDate"
                className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Date Returned to Service */}
            <div className="mb-4">
              <label className="block text-lg font-medium text-gray-700" htmlFor="dateReturnedToService">
                Date Returned to Service:
              </label>
              <input
                type="date"
                id="dateReturnedToService"
                className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Signed Off by Manager */}
            <div className="mb-4">
              <label className="block text-lg font-medium text-gray-700" htmlFor="signedOffByManager">
                Signed Off by Manager:
              </label>
              <input
                type="text"
                id="signedOffByManager"
                className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter manager's name"
              />
            </div>

            {/* Repair Work Order No. */}
            <div className="mb-4">
              <label className="block text-lg font-medium text-gray-700" htmlFor="repairWorkOrderNo">
                Repair Work Order No.:
              </label>
              <input
                type="text"
                id="repairWorkOrderNo"
                className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter work order number"
              />
            </div>

            {/* Notes */}
            <div className="mb-4">
              <label className="block text-lg font-medium text-gray-700" htmlFor="notes">
                Notes:
              </label>
              <textarea
                id="notes"
                className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Any additional notes related to the VOR"
              />
            </div>
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-full md:w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors shadow-lg print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default VORForm;
